import backend from '../services/backend';
import { Link } from './Link';
import SortableTable from './SortableTable';
import { formatDateTime } from '../lib/dateFormat';
import { useQuery } from '@tanstack/react-query';

export default function PageReconstructedDocuments({ pageId }: { pageId: string }) {
  const { data } = useQuery({
    queryKey: ['reconstructed-documents', pageId],
    queryFn: () => backend.listReconstructedDocumentsByPage(pageId).then((res) => res.data),
  });

  const reconstructedDocuments = data?.items ?? [];

  return (
    <div className="mt-8">
      <h2 id="page-reconstructed-documents" className="text-lg font-medium text-gray-900 mb-4 dark:text-zinc-100">
        Reconstructed documents that contain this page
      </h2>

      <div className="overflow-hidden rounded-lg">
        <SortableTable
          storageId="page-reconstructed-documents"
          columns={[
            {
              accessor: 'id',
              label: 'Reconstructed Document ID',
              render: (doc) => (
                <Link to={`/reconstructed-documents/${doc.id}`}>
                  {doc.id.slice(0, 10)}...{doc.id.slice(-10)}
                </Link>
              ),
            },
            {
              accessor: 'position',
              label: 'Page Number',
              render: (doc) => doc.position + 1,
            },
            {
              accessor: 'suggestedFilename',
              label: 'Suggested Filename',
              render: (doc) => doc.suggestedFilename || <span className="text-gray-400">—</span>,
            },
            {
              accessor: 'classification',
              label: 'Classification',
              render: (doc) => doc.classification || <span className="text-gray-400">—</span>,
            },
            {
              accessor: 'createdAt',
              label: 'Created',
              render: (doc) => (doc.createdAt ? formatDateTime(doc.createdAt) : <span className="text-gray-400">—</span>),
            },
          ]}
          data={reconstructedDocuments}
          rowKey={(row) => row.id}
        />
      </div>
    </div>
  );
}
